import { store } from 'react-notifications-component';

export const urlBaseApiPortal = 'http://172.17.5.162/ApiPortal/';
export const urlBaseApiPSE = 'http://172.17.5.162/ApiPaymentGateway/'
export const urlBasePaymentPortalWeb = 'http://172.17.5.162/PaymentPortalWeb/'

export const UrlsPortal = {
  Param : `${urlBaseApiPortal}Param/`,
  Payment : `${urlBaseApiPortal}Payment/`,
  Person : `${urlBaseApiPortal}Person/`,
  ProductPortal : `${urlBaseApiPortal}ProductPortal/`,
  PSE: `${urlBaseApiPSE}api/PSE/`,
  PaymentPortal: `${urlBasePaymentPortalWeb}?GUID=`,
  Audit: `${urlBaseApiPortal}Audit/`,
  PSEListBank: 'https://200.1.124.62/PSEHostingUI/GetBankListWS.aspx?enc='
  }

  export const TimeOutPortal = {
  TimeOutNotification: 3000

  }

export const validateResponse = (response) => {
  
  if (response.ok) {
    return response.json();
  } else {
    store.addNotification({
      title: "Error al realizar transacción",
      message: "Ha ocurrido un error al intentar realizar una transacción",
      type: "danger",
      insert: "top",
      container: "bottom-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: TimeOutPortal.TimeOutNotification,
      }
    });
  }
};

export const exeptionCodeResponse = (error = 'error') => {
  return error;
};

export const getToken = () => {
 const local = localStorage.getItem('persist:root_cotizador_backoffice');
 const localParse = JSON.parse(local);
 return localParse.auth.token;
};

export const fetchHandleError = (url, init)=>
  {
  
    let responsePromise;
    
    if(init)
    {
      responsePromise= fetch(url, init);
    }
    else
    {
      responsePromise= fetch(url);
    }
    return responsePromise.then((response) => validateResponse(response))
      .catch((error) => {
        store.addNotification({
          title: "Error al realizar transacción",
          message: "Ha ocurrido un error al intentar realizar una transacción",
          type: "danger",
          insert: "top",
          container: "bottom-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: TimeOutPortal.TimeOutNotification,
          }
        });
        console.log(error);
        throw exeptionCodeResponse(error);
      })
  }